import { useQuery } from '@tanstack/react-query';
import { apiService } from '../../services/api';
import type { FlightLinksResponse } from '../../types/api';

// STD-015: server state for linking a .bin log to its flight (#1694).
// apiService is imported here (a *.queries.ts file) per STD-016.

export const flightLinksKeys = {
  all: ['flight-links'] as const,
  detail: (objectId: string, day: string | undefined) =>
    [...flightLinksKeys.all, objectId, day ?? null] as const,
};

/**
 * A log's current links and candidate flights. `day` reads another day's
 * flights, for a log whose name carries no clock.
 *
 * The dialog renders failures inline, so the global toast is off.
 */
export function useFlightLinksQuery(objectId: string | undefined, day?: string) {
  return useQuery<FlightLinksResponse, Error>({
    queryKey: flightLinksKeys.detail(objectId ?? '', day),
    enabled: !!objectId,
    meta: { skipGlobalErrorToast: true },
    queryFn: async () => apiService.getFlightLinks(objectId as string, day),
  });
}
